import { useContext } from "react";
import { authContext } from "../contexts/AuthProvider";
import PermissionDenied from "./PermissionDenied";

const PermissionGate = ({ required, children, fallback }) => {
  const { role, permissions } = useContext(authContext);

  if (role === "owner") {
    return <>{children}</>;
  } else if (Array.isArray(permissions) && permissions?.includes(required)) {
    return <>{children}</>;
  } else {
    return <>{fallback || <PermissionDenied />}</>;
  }
};

export default PermissionGate;
